/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page3_Table_MaterialsInputs */



/**
* | output |
* | --- |
* | "Equipment required (potential)" |
*
* @param {Intervention_Plan_Pdf_Page3_Table_MaterialsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page3_table_materials = /** @type {((inputs?: Intervention_Plan_Pdf_Page3_Table_MaterialsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page3_Table_MaterialsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Equipment required (potential)")
	return /** @type {LocalizedString} */ ("Matériel requis (potentiel)")
});